<template>
  <v-text-field
    v-model="hookParentChild"
    :rules="phoneRules"
    :label="$t('phone')"
    :prepend-inner-icon="mdiPhoneOutline"
    v-mask="phoneMask"
    placeholder="+7 (996) 699–66–99"
    name="phone"
    validate-on-blur
    outlined
    required
  ></v-text-field>
</template>

<script>
import { mask } from "vue-the-mask";
import { mdiPhoneOutline } from "@mdi/js";

export default {
  name: "PhoneField",
  directives: { mask },
  data: vm => ({
    phone: "",
    phoneRules: [
      v => !!v || vm.$t("field-requied"),
      v => (v && v.length == 18) || vm.$t("phone-invalid")
    ],
    phoneMask: "+# (###) ###–##–##",
    mdiPhoneOutline: mdiPhoneOutline
  }),
  computed: {
    hookParentChild: {
      get() {
        return this.phone;
      },
      set(phone) {
        this.phone = phone;
        this.$emit("setFormValue", phone);
      }
    }
  }
};
</script>
